<script>
import GmapInfoWindow from '@/components/GmapInfoWindow.vue'
import Vue from 'vue'
import router from '@/router'
import { DataProperty } from '@/rec-cache/rec-cache-types'

// import GmapInfoWindow from '@/components/GmapInfoWindow.vue'
// import humanizeString from 'humanize-string'
// import { DataProperty } from '@/rec-cache/rec-cache-types'

// TODO should be a configuration on app level (vue-wob-cache) being a WoB specific implementation...
// const InfoProps = {
//   postalAddress: 'https://w3id.org/rec/core/hasPostalAddress',
//   zipCode: 'https://w3id.org/rec/core/hasZipCode',
//   city: 'https://w3id.org/rec/core/hasCity',
// }

// const recCoordinates = 'https://w3id.org/rec#coordinates'

export default {
  components: { GmapInfoWindow },
  props: {
    // TODO inject an HTML element with innerHTML set to avoid font icon awareness in this component.
    // mdi: {
    //   type: String,
    //   default: '',
    // },
    icon: {
      // type: Object,
      // default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    geoCoord: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: Object,
      default: () => ({ value: '' }),
    },
    geoCoordId: {
      type: Object,
      default: () => ({ value: '' }),
    },
    coordinates: {
      type: Object,
      default: () => ({ value: '' }),
    },
    // values: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data: () => ({
    marker: '',
    cluster: null,
    clickListener: null,
    domListener: null,
    closeListener: null,
    markerPromiseResolveFn: null,
    show: false,
    infoWindow: null,
  }),
  inject: ['mapPromise', 'clusterPromise'],
  provide: function () {
    const markerPromise = new Promise((resolve) => {
      this.markerPromiseResolveFn = resolve
    })
    return { markerPromise: markerPromise }
  },
  created: async function () {
    console.log('components.gmap-marker.created', this.id.value)

    const gmap = await this.mapPromise
    console.log('components.gmap-marker.created.map-ready', gmap)

    // Create a custom marker element with the MDI icon
    // Using a styled container with the icon element inside
    const markerContent = document.createElement('div')
    markerContent.style.cssText = `
      background: #AFB42B;
      border: 2px solid white;
      border-radius: 50% 50% 50% 0;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      transform: rotate(-45deg);
      position: relative;
    `

    // Add the icon container (counter-rotate the icon so it appears upright)
    const iconContainer = document.createElement('div')
    iconContainer.style.cssText = 'transform: rotate(45deg);'
    iconContainer.appendChild(this.icon)
    markerContent.appendChild(iconContainer)

    const advMarkerViewOptions = {
      position: new this.$gmap.maps.LatLng(
        this.geoCoord.latitude,
        this.geoCoord.longitude
      ),
      map: gmap,
      content: markerContent,
      title: this.title,
    }

    const marker = (this.marker =
      new this.$gmap.maps.marker.AdvancedMarkerElement(advMarkerViewOptions))

    // Add compatibility methods for MarkerClusterer
    // AdvancedMarkerElement doesn't support the traditional marker API
    marker.getPosition = function () {
      return marker.position
    }

    // setMap with recursion guard to prevent infinite loop
    // The AdvancedMarkerElement's map setter internally triggers setMap
    let isSettingMap = false
    marker.setMap = function (map) {
      if (isSettingMap) return
      isSettingMap = true
      try {
        marker.map = map
      } finally {
        isSettingMap = false
      }
    }

    marker.getVisible = function () {
      return marker.map !== null
    }

    this.clickListener = marker.addListener('click', this.onClick)

    this.markerPromiseResolveFn(marker)

    // console.log('components.gmap-marker.created.marker', this.marker)

    // Add to cluster if cluster if defined
    if (this.clusterPromise) {
      // console.log('components.gmap-marker.created.cluster', this.clusterPromise)

      this.cluster = await this.clusterPromise
      this.cluster.addMarker(this.marker, false)
    }

    // Get content for info window.
    const markerIndividual = this.$wob.read(this.geoCoordId, false)
    const infoWindowData = {
      id: this.id.value,
      type: markerIndividual.type.short,
      title: this.title,
      subtitle: this.subtitle,
      dataProps: markerIndividual.properties.filter(
        (p) => p instanceof DataProperty
      ),
      coordinates: this.coordinates,
      // values: this.values,
    }

    // Create info window and mount the info window component to it.
    this.infoWindow = new this.$gmap.maps.InfoWindow()
    this.closeListener = this.infoWindow.addListener('closeclick', () => {
      this.show = false
    })
    const element = document.createElement('div')
    // Generates 5 character random string for HTML attribute id.
    const htmlId = 'id-' + Math.random().toString(36).slice(2, 7)
    element.id = htmlId
    this.infoWindow.setContent(element)

    this.domListener = this.infoWindow.addListener('domready', () => {
      // Injection of router since it's not automatically mounted when using extend method.
      const InfoWindowComponent = Vue.extend({ ...GmapInfoWindow, router })
      new InfoWindowComponent({
        el: `#${htmlId}`,
        data: infoWindowData,
      })
    })
  },
  beforeDestroy: function () {
    // Remove event listener and then marker from cluster.
    this.clickListener.remove()
    this.closeListener.remove()
    this.domListener.remove()
    this.cluster.removeMarker(this.marker, false)
  },
  // render: function (h) {
  //   console.log('components.gmap-marker.render', this.show)
  //   const self = this
  //   return h(GmapInfoWindow, {
  //     props: {
  //       value: self.show,
  //     },
  //     on: {
  //       input: function (e) {
  //         console.log('components.gmap-marker.render.on-input', e)
  //         self.show = e
  //       },
  //     },
  //   })
  // },
  render: function () {
    // console.log('components.gmap-marker.render')
    return null
  },
  methods: {
    onClick: function () {
      // console.log('components.gmap-marker.methods.on-click', this.id.value)
      if (this.show) this.infoWindow.close()
      else this.infoWindow.open({ anchor: this.marker })
      this.show = !this.show

      // this.$emit('click', this.id)

      // Create simple HTML element with contents of the individual on which the geo coordinate exist.
      // TODO more robust implementation needed to cater for non address individuals. WoB has geo reference origos only.
      // const individual = this.$wob.read(this.geoCoordId, false)

      // const titelDiv = `<div style="font-weight:bold; padding-bottom:3px">${this.title}</div>`

      // const typeDiv = `<div style="font-size:x-small;">${humanizeString(
      //   individual.type.short
      // )}</div>`

      // // TODO crude implementation, iteration over inividual must be possible, some kind of a map funcition on the properties based on object...
      // const postalAddress = individual.getValuesByName(
      //   InfoProps.postalAddress
      // )?.[0].value
      // const zipCode = individual.getValuesByName(InfoProps.zipCode)?.[0].value
      // const city = individual.getValuesByName(InfoProps.city)?.[0].value

      // // const addressProps = individual.properties.filter((p) =>
      // //   infoProps.includes(p.name.value)
      // // )
      // // const addressStrs = addressProps
      // //   .map((p) => p.values[0].value)
      // //   .filter((v) => !!v)
      // const addressDivs = `<div>${postalAddress}</div><div>${
      //   zipCode + ' ' + city
      // }</div>`

      // const linkDiv = `<div><a href="/individual/${encodeURIComponent(
      //   individual.id.value
      // )}">Details</a></div>`
      // const element = document.createElement('div')
      // element.innerHTML = `${titelDiv}${typeDiv}${addressDivs}${linkDiv}`

      // this.infoWindow.setContent(element)
      // this.infoWindow.open({ anchor: this.marker })
    },
  },
}
</script>
